import { render, staticRenderFns } from "./CreateExcelTemplateBasedReport.vue?vue&type=template&id=1974ac92"
import script from "./CreateExcelTemplateBasedReport.vue?vue&type=script&lang=js"
export * from "./CreateExcelTemplateBasedReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports